import { defineMessages } from 'react-intl';

/**
 * Copy for the library upload risk opt-in modal (EVI-1566, EV-020) and the
 * image/OCR quality outcome toasts (EV-029).
 */
export const libraryUploadRiskMessages = defineMessages({
  modalIntro: {
    defaultMessage:
      'Uploaded documents are added to your Evidence library and may be used to answer your questions. Please confirm you understand the following before continuing.',
    id: 'HQHpSukvBq',
    description: 'Intro paragraph of the library upload risk opt-in modal',
  },
  riskClinicalSafety: {
    defaultMessage:
      'You remain responsible for the clinical safety of any content you upload. Evidence does not verify uploaded documents, and answers based on them should be clinically reviewed.',
    id: 'NuCozcyKjJ',
    description: 'First risk bullet: clinician retains clinical-safety responsibility',
  },
  riskImages: {
    defaultMessage:
      'Evidence cannot reliably interpret images and diagrams. Scanned pages, photos, or image-only PDFs may be partially or completely unreadable, so content from them may be missing or inaccurate.',
    id: 'iJaHoy0Nyn',
    description:
      'Second risk bullet: Evidence cannot reliably interpret images and diagrams',
  },
  urlIntro: {
    defaultMessage:
      'Adding a website lets Evidence read its publicly available content to help answer your questions. Please confirm you understand the following before continuing.',
    id: 'eBHymsAvV1',
    description: 'Intro paragraph of the library web-source (URL) risk opt-in',
  },
  urlRiskResponsibility: {
    defaultMessage:
      'You are responsible for choosing reputable, clinically appropriate websites. Evidence does not vet the sites you add, so answers drawn from them should be clinically reviewed.',
    id: 'MKB7MJxRbd',
    description:
      'First URL risk bullet: clinician is responsible for selecting safe, clinically appropriate sites',
  },
  urlRiskPublicAccess: {
    defaultMessage:
      'Only add pages that are publicly available without a login. Evidence cannot reach content behind sign-ins, paywalls, or private networks, so those sources will not be read.',
    id: 'N8+VGtmEZO',
    description:
      'Second URL risk bullet: only publicly accessible (no-login) pages can be used',
  },
  acceptCheckboxLabel: {
    defaultMessage: 'I understand and accept these risks',
    id: 'N6LBe1THbj',
    description: 'Checkbox label the user must tick to opt in to the upload risks',
  },
  acceptButton: {
    defaultMessage: 'Accept and continue',
    id: 'ogJ8rIkv0/',
    description: 'Primary button that confirms the risk opt-in and proceeds with upload',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: 'Nnc7NW2zX2',
    description: 'Secondary button that dismisses the risk opt-in modal',
  },
  ocrCardWarningBadge: {
    defaultMessage: 'Poor text quality',
    id: 'ld3/9dd+iW',
    description:
      'Badge on the library document card indicating the extracted text quality is low and content may be inaccurate',
  },
  ocrCardErrorBadge: {
    defaultMessage: 'May be unreadable',
    id: 'MfrHqGV9Ka',
    description:
      'Badge on the library document card indicating OCR confidence was too low to read the document reliably',
  },
  ocrPopoverWarningTitle: {
    defaultMessage: 'Text quality is low',
    id: '3Ah83SvpkJ',
    description:
      'Heading of the popover explaining the low extracted-text-quality badge on the document card',
  },
  ocrPopoverWarningBody: {
    defaultMessage:
      'Heidi extracts the text from your uploads to use as evidence. The text from this document came through with low confidence, so some of it may be missing or inaccurate. Double-check any answers that rely on it, and consider re-uploading a clearer or text-based (non-scanned) version.',
    id: '/JDXjE++bK',
    description:
      'Body of the popover explaining the low extracted-text-quality badge on the document card',
  },
  ocrPopoverErrorTitle: {
    defaultMessage: 'Text couldn’t be read reliably',
    id: 'LC30NGom2H',
    description:
      'Heading of the popover explaining the may-be-unreadable badge on the document card',
  },
  ocrPopoverErrorBody: {
    defaultMessage:
      'Heidi couldn’t reliably extract text from this document — confidence in the extracted text was too low. Answers based on it may be unreliable. Try re-uploading a clearer scan or a text-based (non-scanned) version of the file.',
    id: 'KWe9Wo6ltJ',
    description:
      'Body of the popover explaining the may-be-unreadable badge on the document card',
  },
});
